/**
 * 描述：对数字进行格式化
 * @param {Number} num 数字
 * @param {Number} type 1：金额 2：折扣
 **/
export function formatNumber (num, type) {
  var nums = Number(num)
  if (Number.isInteger(nums)) {
    return nums.toString()
  } else {
    if (Number(type) === 1) {
      return nums.toFixed(0)
    } else {
      return nums.toFixed(1)
    }
  }
}

/**
 * 描述：判断传值是否小于当前时间
 * @param {String} date 时间 2024-01-01 00:00:00
 **/
export function compareDate (date) {
  let now = new Date()
  let nowTime = now.getTime()
  let dateTime = new Date(date.replace(/-/g, '/')).getTime()
  if (nowTime > dateTime) {
    return true
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js